import { useState } from 'react';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useHistory, useParams } from 'react-router-dom';

import {
  useGetQuestionByIdQuery,
  useUpdateQuestionByPkMutation,
  TeacherAssignmentQuestionsFragment,
} from '@school_ify/schoolify-repository/src/teacher/types';
import { AssignmentQuestionTypesEnum } from '@school_ify/schoolify-repository/src/shared/types';

import { getQuestionTypeFromString } from 'utils/quiz';
import { CreateEditQuestionModel } from 'types/quiz';

import MultipleOptionsQuestion from '../shared/MultipleOptionsQuestion/MultipleOptionsQuestion';
import FillInBlankQuestion from '../shared/FillInBlankQuestion/FillInBlankQuestion';
import OpenQuestion from '../shared/OpenQuestion/OpenQuestion';

interface ParamsProps {
  questionType: string;
  quizId: string;
  questionId: string;
}

const EditQuestion = () => {
  const { questionType, quizId, questionId } = useParams<ParamsProps>();
  const [editQuestion, setEditQuestion] = useState<TeacherAssignmentQuestionsFragment>(null);
  const history = useHistory();

  useGetQuestionByIdQuery({
    variables: {
      id: questionId,
    },
    onCompleted: fetchedData => {
      if (fetchedData) setEditQuestion(fetchedData?.assignment_questions_by_pk || null);
    },
  });

  const [updateQuestionMutation] = useUpdateQuestionByPkMutation();
  const handleEditQuestion = (model: CreateEditQuestionModel) => {
    updateQuestionMutation({
      variables: {
        questionId,
        question: {
          assignment_id: quizId,
          title: model.title,
          content: model.content,
          type: getQuestionTypeFromString(questionType),
        },
        question_options: model.questionOptions.map(option => ({
          ...option,
          assignment_question_id: questionId,
        })),
      },
      onCompleted: () => history.push(`/quiz/edit/${quizId}`),
    });
  };

  const project = () => {
    switch (questionType) {
      case AssignmentQuestionTypesEnum.PICK_OPTIONS:
        return (
          <MultipleOptionsQuestion
            createOrUpdateQuestion={handleEditQuestion}
            editQuestion={editQuestion}
          />
        );
      case AssignmentQuestionTypesEnum.FILL_IN_BLANK:
        return (
          <DndProvider backend={HTML5Backend}>
            <FillInBlankQuestion
              createOrUpdateQuestion={handleEditQuestion}
              editQuestion={editQuestion}
            />
          </DndProvider>
        );
      case AssignmentQuestionTypesEnum.OPEN_QUESTION:
        return (
          <OpenQuestion createOrUpdateQuestion={handleEditQuestion} editQuestion={editQuestion} />
        );
      default:
        return <></>;
    }
  };

  return project();
};

export default EditQuestion;
